import { render, staticRenderFns } from "./auth-form-register.vue?vue&type=template&id=b9b551b0&scoped=true"
import script from "./auth-form-register.vue?vue&type=script&lang=js"
export * from "./auth-form-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b551b0",
  null
  
)

export default component.exports